// extracted by mini-css-extract-plugin
export default {"layoutIcon":"kjvU5B","fillBlue":"IcAZuD","strokeBlue":"S6OiEL","fillWhite":"sb3_PK","strokeWhite":"YFfZNF","active":"BfWsrD","searchFadeIn":"xQXWZz"};